export const Actions = {
    REMOVE_BANK_ACCOUNT_SELECT: 'REMOVE_BANK_ACCOUNT_SELECT',
    REMOVE_BANK_ACCOUNT_RESET: 'REMOVE_BANK_ACCOUNT_RESET',
};
